<template>
  <tbody>
    <tr>
      <th
        :colspan="6"
        class="text-left body-1"
      >
        <span class="headline title-column">{{department.Name}}</span>
        <!-- 編輯部門預算備註 -->
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="title-column">
              <v-btn
                icon
                dark
                @click="projectBudgetIDEditingComment=item.ID;isShowProjectBudgetCommentDialog=true;"
              >
                <v-icon v-show="item.Remark && item.Remark.length">mdi-comment-text-outline</v-icon>
                <v-icon v-show="!(item.Remark && item.Remark.length)">mdi-comment-outline</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-show="item.Remark && item.Remark.length">{{item.Remark}}</span>
          <span v-show="!(item.Remark && item.Remark.length)">沒有內容</span>
        </v-tooltip> -->
        <!-- <span class="title-column" v-if="isMoneyVisible">部門分配獎金: ${{item.Budget | amountFormat}}</span> -->
        <span class="title-column" v-if="isMoneyVisible">已分配獎金: ${{totalTaskBudget | amountFormat}}</span>
        <span class="title-column" v-if="isMoneyVisible">總實發獎金 : ${{totalIssuedBonus | amountFormat}}</span>
        <!-- <v-spacer></v-spacer> -->

        <!-- 編輯部門預算 -->
        <!-- <v-tooltip
          top
          v-if="canEditProjectBudget"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                v-if="canEditProjectBudget"
                color="primary"
                fab
                dark
                small
                @click.stop="editProjectDepartment"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-if="!isProjectFinished">編輯部門預算</span>
          <span v-else>專案已結束</span>
        </v-tooltip> -->

        <!-- 刪除部門預算 -->
        <!-- <v-tooltip
          top
          v-if="canEditProjectBudget"
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-btn
                v-if="canEditProjectBudget"
                color="accent "
                fab
                dark
                small
                :disabled="!canDeleteThisBudget"
                @click.stop="confirmDeleteBudget"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </span>
          </template>
          <span v-if="isProjectFinished">專案已結束</span>
          <span v-else-if="!canDeleteThisBudget">無法刪除，日誌已審核獎金</span>
          <span v-else>刪除部門預算</span>
        </v-tooltip> -->

        <v-tooltip
          top
          v-if="canEditTaskOfThisDepartment"
        >
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              style="float: right"
            >
              <v-btn
                :disabled="isProjectFinished"
                color="primary "
                dark
                @click.stop="addTask"
              >
                <v-icon>mdi-plus</v-icon>

              </v-btn>
            </span>
          </template>
          <span v-if="!isProjectFinished">新增任務</span>
          <span v-else>專案已結束</span>
        </v-tooltip>
      </th>
    </tr>
    <tr>
      <th>負責人</th>
      <th>任務</th>
      <th v-show="!isMobile">主管分配獎金</th>
      <th v-show="!isMobile">總實發獎金</th>
      <th v-show="!isMobile">備註</th>
      <th>操作</th>
    </tr>

    <task-table-row
      v-for="task in projectBudgetTasks"
      :key="`budget-${item.ID}-task-${task.ID}`"
      :item="task"
      @edit="editTask(task)"
      @remove="deleteTask(task)"
    />
    <tr v-if="!projectBudgetTasks.length">
      <td
        colspan="6"
        class="text-center"
      >(尚未規劃任務)</td>
    </tr>

    <task-addedit-dialog
      v-model="isShowTaskAddeditDialog"
      :editing-id="editingTaskId"
      :project-id="item.ProjectID"
      :stage="projectStage"
      :department-id="item.DepartmentID"
      :project-department-budget-id="editingTaskProjectDepartmentBudgetID"
    />
    <project-budget-comment-dialog
      v-model="isShowProjectBudgetCommentDialog"
      :editing-id="projectBudgetIDEditingComment"
    />
  </tbody>
</template>

<script>
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import TaskAddeditDialog from "@/ui/project/task/task-addedit-dialog.vue";
import TaskTableRow from "./project-dialog-task-table-row.vue";
import ProjectBudgetCommentDialog from "./budget/project-budget-comment-dialog";
export default {
  mixins: [filterMixin],
  components: { TaskTableRow, TaskAddeditDialog, ProjectBudgetCommentDialog },
  props: {
    item: {
      type: Object,
      required: true
    },
    projectStage: {
      type: String,
      required: true
    }
  },
  data: () => ({
    // task
    editingTaskId: -1,
    editingTaskProjectDepartmentBudgetID: -1,
    isShowTaskAddeditDialog: false,
    // comment
    isShowProjectBudgetCommentDialog: false,
    projectBudgetIDEditingComment: -1
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    projectBudgetTasks() {
      return this.activeTaskList.filter(
        o => o.ProjectDepartmentBudgetID == this.item.ID
      );
    },
    department() {
      return this.departments.find(o => o.ID == this.item.DepartmentID) || {};
    },
    totalTaskBudget() {
      return this.tasks.filter(o=>o.ProjectDepartmentBudgetID == this.item.ID).reduce((sum, task) => sum + task.Amount, 0);
    },
    project() {
      return this.projects.find(o => o.ID == this.item.ProjectID) || {};
    },
    isProjectFinished() {
      return ["未得標", "已結案", "已完成"].includes(this.project.Status);
    },
    totalIssuedBonus() { // 該轉案、該部門、該階段
      let tasks = this.tasks.filter(
        o =>
          o.ProjectID == this.project.ID && o.DepartmentID == this.department.ID && o.ProjectStage == this.projectStage
      );
      let workingItems = this.taskWorkingItems.filter(
        o => tasks.findIndex(t => t.ID == o.TaskID) >= 0
      );
      return workingItems.reduce(
        (sum, o) => sum + (o.BonusReleasedAt ? o.Bonus : 0),
        0
      );
    },
    canEditTaskOfThisDepartment() {
      return (
        this.canEditTask &&
        (this.myLevel > 10 ||
          (this.myLevel == 10 &&
            this.item.DepartmentID == this.myDepartment.ID))
      );
    },
    canDeleteThisBudget () {
      return this.item.Deletable
      /* 2021/1/15 v1.4.20 過於lag，v1.4.21 加入了「Deletable」
      // 找到已經審核的taskWorkingItem
      const findTaskWorkingItemTask = o =>
        this.tasks.find(task => task.ID == o.TaskID) || {};
      return (
        this.taskWorkingItems
          .filter(o => findTaskWorkingItemTask(o).ProjectDepartmentBudgetID == this.item.ID)
          .findIndex(o => o.Status == "獎金發放中" || o.Status == "已完成") < 0
      );*/
    },
    isMoneyVisible () {
      return this.myLevel >= 10
    },
    ...mapGetters([
      "myLevel",
      "myDepartment",
      "canEditTask",
      "canEditProjectBudget",
      "departments",
      "projects",
      "tasks",
      "taskWorkingItems",
      "activeTaskList"
    ])
  },
  methods: {
    // task
    addTask() {
      this.editingTaskId = -1;
      this.editingStage = this.projectStage;
      this.editingTaskDepartmentID = this.item.DepartmentID;
      this.editingTaskProjectDepartmentBudgetID = this.item.ID;
      this.isShowTaskAddeditDialog = true;
    },
    editTask(task) {
      this.editingTaskId = task.ID;
      this.editingStage = this.projectStage;
      this.editingTaskDepartmentID = this.item.DepartmentID;
      this.editingTaskProjectDepartmentBudgetID = this.item.ID;
      this.isShowTaskAddeditDialog = true;
    },
    deleteTask(item) {
      const removingIdx = this.$store.state.task.list.indexOf(item);

      this.isLoading = true;
      this.$services.task
        .inActivate(this, item.ID)
        .then(res => {
          this.$store.state.task.list[removingIdx].IsActive = false;
          this.$store.state.task.list.splice(removingIdx, 1)
          // this.$alertMessage("成功刪除任務「" + item.Name + "」!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // department budget
    editProjectDepartment() {
      this.$emit("edit", this.item);
    },
    confirmDeleteBudget() {
      if (!this.canDeleteThisBudget) {
        alert("無法刪除部門預算!\n有已審核獎金的工作日誌!");
        return;
      }
      if (
        confirm(
          `確定刪除「${this.department.Name}」部門預算($${this.item.Budget})?`
        )
      )
        this.$emit("remove", this.item);
    }
  }
};
</script>

<style scoped>
.title-column {
  /* width: calc(25% - 40px);
  display: inline-block; */
  margin-right: 16px;
}
</style>